import { Box, Button, Grid, Typography } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { isEmpty } from 'lodash-es';
import React, { Component } from 'react';
import { toast } from 'react-toastify';
import InputText from '../../../../commonModules/interface/form-input-inline';
import FormProduct from './FormProduct';

class DuplicateTo extends Component {
    state = { 
        sending: false,
        match_dest_email: "",
        match_dest_account: "",
        step: 1,
        match_products: {},
        errors:{
            match_dest_email: "",
        },
        confirmSubmit:false,
        photoWarning: false,
        backendError: null,
        loadingPhotos: false,
        photoValidationResult: null,
        showPhotoOptions: false,
    }
    
    componentDidMount() {
        // Reset Redux state to ensure button is not disabled
        if (this.props.resetProductState) {
            this.props.resetProductState();
        }
    }
    
    handleChangeEmail = (e) => {
        const { name, value} = e.target;
        this.setState({ [name]: value })
    }
    
    loadPhotoData = async (filename) => {
        try {
            console.log('loadPhotoData: Chargement de la photo:', filename);
            const response = await fetch(`/stocks/getPhotos`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ path: filename }), // ✅ Utiliser 'path' au lieu de 'filename'
                credentials: 'same-origin',
            });
            
            if (!response.ok) {
                throw new Error(`Erreur ${response.status}: ${response.statusText}`);
            }
            
            const result = await response.json();
            console.log('loadPhotoData: Réponse reçue pour', filename, ':', result);
            
            if (result.error) {
                throw new Error(result.error);
            }
            
            // Vérifier que les données sont valides (l'API retourne 'uri' et non 'data_uri')
            if (!result.uri || result.uri.trim() === '') {
                throw new Error('Données d\'image vides');
            }
            
            console.log('loadPhotoData: Photo chargée avec succès:', filename);
            return result.uri; // ✅ Retourner 'uri' au lieu de 'data_uri'
        } catch (error) {
            console.error('loadPhotoData: Erreur lors du chargement de la photo:', filename, error);
            throw error;
        }
    }
    validateStep1 = async () => {
        await this.findUserAccountID()
        if(this.state.match_dest_account){
            // Validate photos before proceeding
            await this.validatePhotos()
        }
    }
    
    validatePhotos = async () => {
        const { product } = this.props;
        
        if (!product || !product.photos || product.photos.length === 0) {
            // Pas de photos, on peut continuer
            this.changeStep(2);
            return;
        }
        
        this.setState({ loadingPhotos: true });
        
        const validationResult = {
            totalPhotos: product.photos.length,
            validPhotos: [],
            invalidPhotos: [],
            photosWithData: [],
            errors: []
        };
        
        // Tester chaque photo
        for (const photo of product.photos) {
            console.log('validatePhotos: Traitement de la photo:', photo);
            
            if (photo.data_uri && photo.data_uri.trim() !== '') {
                // Photo déjà avec données valides
                console.log('validatePhotos: Photo avec data_uri existant');
                validationResult.validPhotos.push({
                    filename: photo.filename || '',
                    filetype: photo.filetype || '',
                    data_uri: photo.data_uri
                });
                validationResult.photosWithData.push(photo);
            } else if (photo.filename) {
                // Tenter de charger la photo depuis le serveur
                console.log('validatePhotos: Tentative de chargement de la photo:', photo.filename);
                try {
                    const photoData = await this.loadPhotoData(photo.filename);
                    if (photoData && photoData.trim() !== '') {
                        console.log('validatePhotos: Photo chargée avec succès');
                        validationResult.validPhotos.push({
                            filename: photo.filename,
                            filetype: photo.filetype || 'image/jpeg',
                            data_uri: photoData
                        });
                        validationResult.photosWithData.push(photo);
                    } else {
                        console.log('validatePhotos: Données de photo vides');
                        validationResult.invalidPhotos.push(photo);
                        validationResult.errors.push(`Photo "${photo.filename}" : données introuvables`);
                    }
                } catch (error) {
                    console.error('validatePhotos: Erreur lors du chargement:', error);
                    validationResult.invalidPhotos.push(photo);
                    validationResult.errors.push(`Photo "${photo.filename}" : ${error.message}`);
                }
            } else {
                // Photo sans filename ni data_uri
                console.log('validatePhotos: Photo sans filename ni data_uri');
                validationResult.invalidPhotos.push(photo);
                validationResult.errors.push('Photo sans nom de fichier ni données');
            }
        }
        
        this.setState({ 
            loadingPhotos: false,
            photoValidationResult: validationResult
        });
        
        // Décider de la suite selon les résultats
        if (validationResult.invalidPhotos.length === 0) {
            // Toutes les photos sont valides
            this.setState({ photoWarning: false });
            this.changeStep(2);
        } else {
            // Il y a des photos problématiques, demander à l'utilisateur
            this.setState({ 
                showPhotoOptions: true,
                photoWarning: true 
            });
        }
    }
    changeStep = (step) => {
        this.setState({
            step,
        })
    }

    findUserAccountID = async () => {
        const { match_dest_email } = this.state;
        if( !isEmpty(match_dest_email)){

            /***** STEP 1 ******/
                // send email to global DB
                // check if email correspond to existing user and return Stock Account ID
            try {
                let req = await fetch('/stocks/match/find/account',{
                    method:'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content,
                    },
                    body: JSON.stringify({email: match_dest_email}),
                    credentials: 'same-origin',
                })
                const res = await req.json()
                console.log('====================================');
                console.log("findUserAccountID", {res});
                
                if(!res.error && !isEmpty(res.accountID) ){

                    this.setState({
                        match_dest_account: res.accountID,
                        errors: {
                            ...this.state.errors,
                            match_dest_email: ""
                        }
                    })
    
                } else {
                    toast.error("Pas de compte correspondant à cet email")
                }
            } catch (error) {
                console.log("catch findUserAccountID", error);
                
                toast.error( "Un Problème est survenu")
            }
        } else {
            this.setState({
                ...this.state,
                errors: {
                    ...this.state.errors,
                    match_dest_email: "Veuillez remplir ce champ"
                }
            })
        }
    }
    
    handleDuplicateWithErrorHandling = async (productData) => {
        try {
            this.setState({ 
                backendError: null
            });
            
            // Optional: Add frontend validation for product name
            if (!productData.name || productData.name.trim() === '') {
                throw new Error('Le nom du produit est requis');
            }
            
            console.log('DuplicateTo: Starting duplication for product:', productData.name);
            
            // ✅ IMPORTANT: Ajouter les photos validées au produit avant l'envoi
            const { photoValidationResult } = this.state;
            if (photoValidationResult && photoValidationResult.validPhotos && photoValidationResult.validPhotos.length > 0) {
                // Ajouter les photos validées avec le bon format (URI en majuscules)
                productData.photos = photoValidationResult.validPhotos.map(photo => ({
                    filename: photo.filename || '',
                    filetype: photo.filetype || 'image/jpeg',
                    URI: photo.data_uri
                }));
                console.log('DuplicateTo: Photos ajoutées au produit:', productData.photos.length);
            } else {
                console.log('DuplicateTo: Aucune photo validée, duplication sans photos');
                productData.photos = [];
            }
            
            await this.props.duplicateProduct(productData);
            console.log('DuplicateTo: Duplication completed successfully');
        } catch (error) {
            console.error('DuplicateTo: Duplication error caught:', error);
            console.error('DuplicateTo: Error message:', error.message);
            this.handleBackendError(error.message || 'Une erreur est survenue lors de la duplication');
        }
    }
    
    handleBackendError = (errorMessage) => {
        this.setState({ 
            backendError: errorMessage 
        });
        toast.error(errorMessage);
        
        // Force reset Redux state if it's stuck
        if (this.props.resetProductState) {
            setTimeout(() => {
                console.log('DuplicateTo: Force resetting product state after error');
                this.props.resetProductState();
            }, 1000);
        }
    }
    
    handlePhotoOption = (option) => {
        const { photoValidationResult } = this.state;
        
        switch (option) {
            case 'skip_invalid':
                // Continuer sans les photos invalides
                this.setState({ 
                    showPhotoOptions: false,
                    photoWarning: false 
                });
                this.changeStep(2);
                break;
                
            case 'skip_all':
                // Continuer sans aucune photo
                this.setState({ 
                    showPhotoOptions: false,
                    photoWarning: false,
                    photoValidationResult: {
                        ...photoValidationResult,
                        validPhotos: []
                    }
                });
                this.changeStep(2);
                break;
                
            case 'cancel':
                // Annuler la duplication
                this.setState({ 
                    showPhotoOptions: false,
                    photoWarning: false,
                    photoValidationResult: null 
                });
                break;
                
            default:
                break;
        }
    }
    render() {
        // Debug Redux state
        console.log('DuplicateTo render - Redux state:', {
            fetching: this.props.STATE?.products?.fetching,
            fetched: this.props.STATE?.products?.fetched,
            error: this.props.STATE?.products?.error,
            fullState: this.props.STATE?.products
        });
        
        return (
            <Box>
                {this.state.step == 1 &&
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <InputText 
                            name="match_dest_email"
                            value={this.state.match_dest_email}
                            error={this.state.errors.match_dest_email}
                            errorClass={!!this.state.errors.match_dest_email}
                            change={this.handleChangeEmail}
                            title="Compte Destinataire"
                            placeholder="Entrez l'email du compte destinataire"
                        />                    
                    </Grid>
                    
                    <Grid item xs={12}>
                        <Button color="secondary" variant="contained" onClick={ this.validateStep1 }>Valider</Button>
                        <Button color="secondary" onClick={this.props.handleCloseForm}>Annuler</Button>
                    </Grid>
                </Grid> 
                }
                {this.state.showPhotoOptions && this.state.photoValidationResult && (
                    <Box>
                        <Alert severity="warning" style={{ marginBottom: '16px' }}>
                            <Typography variant="h6" gutterBottom>
                                Problème avec les photos
                            </Typography>
                            <Typography variant="body2" paragraph>
                                {this.state.photoValidationResult.invalidPhotos.length} photo(s) sur {this.state.photoValidationResult.totalPhotos} ne peuvent pas être dupliquées :
                            </Typography>
                            <ul>
                                {this.state.photoValidationResult.errors.map((error, index) => (
                                    <li key={index}><Typography variant="body2">{error}</Typography></li>
                                ))}
                            </ul>
                            <Typography variant="body2" paragraph style={{ marginTop: '16px' }}>
                                Que souhaitez-vous faire ?
                            </Typography>
                            <Box style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                                {this.state.photoValidationResult.validPhotos.length > 0 && (
                                    <Button 
                                        variant="contained" 
                                        color="primary"
                                        onClick={() => this.handlePhotoOption('skip_invalid')}
                                    >
                                        Continuer avec {this.state.photoValidationResult.validPhotos.length} photo(s) valide(s)
                                    </Button>
                                )}
                                <Button 
                                    variant="outlined" 
                                    color="secondary"
                                    onClick={() => this.handlePhotoOption('skip_all')}
                                >
                                    Continuer sans photos
                                </Button>
                                <Button 
                                    variant="outlined"
                                    onClick={() => this.handlePhotoOption('cancel')}
                                >
                                    Annuler
                                </Button>
                            </Box>
                        </Alert>
                    </Box>
                )}
                {this.state.step == 2 &&
                    <Box>
                        {this.state.loadingPhotos && (
                            <Alert severity="info" style={{ marginBottom: '16px' }}>
                                <Typography variant="body2">
                                    <strong>Chargement en cours...</strong> Récupération des photos depuis le serveur pour la duplication...
                                </Typography>
                            </Alert>
                        )}
                        
                        {this.state.photoValidationResult && this.state.photoValidationResult.validPhotos.length > 0 && !this.state.showPhotoOptions && (
                            <Alert severity="success" style={{ marginBottom: '16px' }}>
                                <Typography variant="body2">
                                    <strong>✅ Photos prêtes :</strong> {this.state.photoValidationResult.validPhotos.length} photo(s) ont été chargées et seront dupliquées avec le produit.
                                </Typography>
                            </Alert>
                        )}
                        
                        {this.state.backendError && (
                            <Alert severity="error" style={{ marginBottom: '16px' }}>
                                <Typography variant="body2">
                                    <strong>Erreur:</strong> {this.state.backendError}
                                </Typography>
                                {this.props.STATE?.products?.fetching && (
                                    <Box style={{ marginTop: '8px' }}>
                                        <Button 
                                            size="small" 
                                            variant="outlined" 
                                            onClick={() => {
                                                console.log('Manual reset of product state');
                                                if (this.props.resetProductState) {
                                                    this.props.resetProductState();
                                                }
                                                this.setState({ backendError: null });
                                            }}
                                        >
                                            Réinitialiser
                                        </Button>
                                    </Box>
                                )}
                            </Alert>
                        )}
                        
                         <FormProduct
                             {...this.props}
                             updateProduct={this.handleDuplicateWithErrorHandling}
                             product={this.props.product}
                             match_dest_account={this.state.match_dest_account}
                             update
                             duplicate
                             onError={this.handleBackendError}
                         />
                    </Box>
                }
            </Box>
        );
    }
}

export default DuplicateTo;